import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import Newsletter from "@/pages/Newsletter";

export const Route = createFileRoute("/es/suscribirse")({
  head: () => buildRouteHead("/es/suscribirse"),
  component: Newsletter,
});

